var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageSection',{attrs:{"title":_vm.title || '',"description":_vm.description || '',"viewAll":_vm.viewAll}},[_c('ResourcesGrid',_vm._b({},'ResourcesGrid',{emptyState: _vm.emptyState, max: _vm.max, topic: _vm.topic, paginate: _vm.paginate, subcategory: _vm.subcategory},false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }